import { get, post, put, del } from "@/fn/ajax";
import Mock from "mockjs";

/**
 * @param  {any} query
 *  登录
 */
export async function login(query: any) {
  const data = await post("/user/login", query);
  return data;
}

/**
 * @param  {any} query
 *  登录
 */
export async function logout() {
  const data = await post("/user/logout");
  return data;
}

/**
 * @param  {any} query
 *  忘记密码
 */
export async function findMyPassword(query: any) {
  const data = await post("/user/findMyPassword", query);
  return data;
}

/**
 * @param  {any} query
 *  修改密码
 */
export async function modifyPassword(query: any) {
  const data = await post("/user/modifyPassword", query);
  return data;
}
/**
 * @param  {any} query
 *  校验邮件激活码
 */
export async function verifyEmailActiveCode(query: any) {
  const data = await get("/user/verifyEmailActiveCode", query);
  return data;
}
/**
 * @param  {any} query
 *  重置密码
 */
export async function resetPassword(query: any) {
  const data = await post("/user/resetPassword", query);
  return data;
}

/**
 * 找回密码
 */
export async function findPass(query: any) {
  const data = await get('/user/mail/findUser', query)
  return data
}
